import {Classes} from '@blueprintjs/core'
import {ContextMenu2ChildrenProps, Popover2} from '@api'
import {CustomAttributeInfoCard, GroupByButtons, GroupBySpecInfoCard, InlineAggregateDetails, FarRightFlatModeGroupByButtons, GroupSwatches, GroupByGroupCardContentsExtra, GroupByGroupHeroCards} from '@modules'
import {GroupByGroupHeaderDropIndicator, GroupByGroupHeaderDropStatusIndicator} from '@modules/catalog/internal/gridList/components/groupBy/GroupByCatalog/GroupByCatalog_Groups/GroupByCatalog_LoadMore/GroupByGroupHeaderDropIndicator'
import {GroupByGroupHeaderExtraContent, useGroupByGroupStore} from './'
import * as css from './GroupByCatalogGroups.css'
import {site, ui} from '@stores'
import {_, classNames, React, useEffect, observer, Fragment} from '@api'
import useMeasure from 'react-use-measure'
import * as styles from './GroupByGroupHeader.css'

export const GroupByGroupHeader = observer<{ onSetRef?, contextMenuProps?: ContextMenu2ChildrenProps}>(function GroupByGroupHeader({onSetRef, contextMenuProps}) {
  const groupByStore = useGroupByGroupStore(),
    {
      buttonToolbarProps, groupHeader,
      isExpanded, isSelected, size,
      cardData, preload, busy, isUnassigned, grouping,
      specStack, isCustomAttribute, showSwatches,
      isFlat, isCard, levelOfDetail, grouping: {isLeaf, fieldDefinition}, showDropIndicator,
      props: {
      firstExpandedInRow, path, tabIndex, group,
      hideChildren, info, level, groupName,
      className, mustTerms, mustNotTerms,
      attract, index, inGridCell, assortmentCard,
      ...restProps},
      showingAggregateDetails, forceShowInlineAggregationDetails,
      groupDragDropEvents, parentStore,
      settings: {fullWidth, singleLine, columnView},
      headerTop, headerHeight, groupView, isSpec, hasToolbarPopover, showingInlineAggregationDetails, onContextMenu, groupBy,
      catalog: {sidebar, isProductView, aggregation, groupBy: {canShowSwatchesAndHeroCards, settings: {noWrap, heroCards: settings}}, showGroupHeader, settings: {aggregateLocation, imageRatio, viewMode, showAggDetailsWhenCollapsed}}
    } = groupByStore,
    dataAttrs = {
      ...fieldDefinition?.group?.groupDomAttributes,
      'data-level': level,
      'data-in-grid-cell': inGridCell ? true : undefined,
      'data-has-subtitle': groupByStore.infoCardProps.data.subtitle1 != null,
      'data-full-width': (fullWidth || (!isProductView && viewMode === 'table')) ? true : undefined,
      'data-column-view': columnView, // will break CSS in groupByGroup ? true : undefined,
      'data-single-line': singleLine ? true : undefined,
      'data-header': showGroupHeader ? true : undefined,
      'data-is-spec': isSpec ? isSpec : undefined,
      'data-image-ratio': imageRatio,
      'data-lod': levelOfDetail,
      'data-group-type': isCustomAttribute ? 'customAttribute' : 'spec',
      'data-size': size,
      'data-hide-children': hideChildren ? hideChildren : undefined,
      'data-view': groupView,
      'data-wrap': !noWrap ? true : undefined,
      'data-leaf': isLeaf ? true : undefined,
      'data-selected': isSelected ? true : undefined,
      'data-expanded': isExpanded ? true : undefined,
      'data-group-name': groupName,
      'data-index': index,
      'data-drag-over': showDropIndicator ? true : undefined,
      'data-has-label': groupByStore.groupTitle != null,
      'data-attract': attract ? attract : undefined,
      'data-showing-inline-aggregation': showingInlineAggregationDetails ? showingInlineAggregationDetails : undefined,
      'data-is-aggregation-sidebar-group': aggregation.isShowingAggregateDetails && aggregation.aggregateDetailsGroup.store === groupByStore ? true : undefined,
      'data-expanded-card-view': groupView === 'card' && isExpanded ? true : undefined
    },
    inlineStyles : any = {
      '--columns': parentStore?.settings?.childColumns ?? 2,
      '--level': level,
      '--header-top': `${headerTop}px`,
      '--header-height': `${headerHeight}px`
    },
    
    headerComponent = (
      <div key={group}
           ref={onSetRef}
           data-type='GroupByGroupHeader'
           data-key={info.key}
           style={inlineStyles}
           {...dataAttrs}
           tabIndex={tabIndex}
           {...groupDragDropEvents.events}
           className={classNames(styles.root, className, contextMenuProps.className, Classes.FIXED_POSITIONING_CONTAINING_BLOCK)}
           {..._.omit(restProps, 'isExpanded', 'groupCount', 'specs', 'node', '__typename', 'specStack')}
           onClick={site.touchDevice ? undefined : groupByStore.onClick}
           onMouseEnter={!preload && !isExpanded ? groupByStore.onMouseEnter : undefined}
           onMouseLeave={!preload && !isExpanded ? groupByStore.onMouseLeave : undefined}
           onTouchEnd={site.touchDevice ? e => {
             groupByStore.onClick(e as any)
             groupByStore.onTouchDoubleTap(e)
           } : undefined}
      >
      {/* A card (or flat mode row) for the group that we're in */}
      <div className={classNames(styles.contents)}>
        {<Fragment>
           {/*<GroupImportDropIndicator/>*/}
           {showGroupHeader && groupHeader}
           {isCustomAttribute ?
            <CustomAttributeInfoCard
              {...groupByStore.infoCardProps as any}
              key={info.key}
              groupView='flat'
              def={grouping.def}
              className={classNames(styles.headerCard, groupByStore.infoCardProps.className)}
              info={info}
              isSelected={isSelected && level == 0}
              data={cardData}
              success={groupByStore.success}
              specStack={specStack}
              isUnassigned={isUnassigned}
              level={level}
              group={group} path={path}
              leftActions={(isCard ?
                            <GroupByButtons showCollapseOnly grouping={groupByStore.grouping} disabledButtons={busy} location={isCard ? 'card' : 'row'} {...buttonToolbarProps}
                                            className={css.attributeButtons} isUnassigned={isUnassigned} specStack={specStack}
                                            level={level}/>
                                   : <GroupByButtons showCollapseOnly grouping={groupByStore.grouping} specStack={specStack} location='row' {...buttonToolbarProps} data-align='left'/>)}
              rightActions={<Fragment>
                {hasToolbarPopover ? null : <Fragment>
                {(isCard ?
                                             <GroupByButtons grouping={groupByStore.grouping} disabledButtons={busy} location={isCard ? 'card' : 'row'} {...buttonToolbarProps}
                                                             className={classNames(css.attributeButtons, styles.rightActionButtons)} isUnassigned={isUnassigned} specStack={specStack}
                                                             level={level} data-align='right'/>
                                                    : <GroupByButtons className={styles.rightActionButtons} grouping={groupByStore.grouping} specStack={specStack} location='row' {...buttonToolbarProps} data-align='right'/>)}
              </Fragment>}
              </Fragment>}
              extra={<Fragment>
                {!hasToolbarPopover && <FarRightFlatModeGroupByButtons/>}
                {/*<GroupByGroupHeaderDropIndicator className={styles.dropIndicator}/>*/}
                <GroupByGroupHeaderDropStatusIndicator/>
                <GroupByGroupCardContentsExtra/>
              </Fragment>}
            /> :
            <GroupBySpecInfoCard
              {...groupByStore.infoCardProps}
              className={classNames(styles.headerCard, groupByStore.infoCardProps.className)}
              imageExtra={groupView == 'card' && <GroupByGroupHeaderDropStatusIndicator/>}
              leftActions={<GroupByButtons showCollapseOnly grouping={groupByStore.grouping} specStack={specStack} location='row' {...buttonToolbarProps} data-align='left'/>}
              rightActions={<Fragment>
                {hasToolbarPopover ? null :
                            <Fragment>
                  <GroupByButtons grouping={groupByStore.grouping} specStack={specStack} location='row' {...buttonToolbarProps} className={classNames(styles.rightActionSpecButtons)} data-align='right'/>
                </Fragment>}
                {/*{false && <div className={styles.subgroupAndSwatches}>*/}
                {/*  {(!hideSubgroupsWhenCollapsed || isExpanded) && <GroupByGroupHeroCards key={grouping.groupDefinition?.subGroup?.field}/>}*/}
                {/*  {showSwatches && (isExpanded || groupBy.settings.showSwatchesWhenCollapsed) && (level == 0 || !isLeaf) && <GroupSwatches className={styles.swatches}/>}*/}
                {/*</div>}*/}
              </Fragment>}
              extra={<Fragment>
                {groupView === 'flat' && <GroupByGroupHeaderDropStatusIndicator/>}
                {!hasToolbarPopover && <FarRightFlatModeGroupByButtons/>}
                {/*<GroupByGroupHeaderDropIndicator className={styles.dropIndicator}/>*/}
                <GroupByGroupCardContentsExtra/>
              </Fragment>}
            />}
           {!isFlat && !isCustomAttribute  && //&& !loading && !busy && (isExpanded || isTouchDevice() || mouseHasEntered) &&
		    <GroupByButtons grouping={groupByStore.grouping} specStack={specStack} location={isCard ? 'card' : 'row'} isUnassigned={isUnassigned} {...buttonToolbarProps}
		                    level={level}/>
           }
           {/*{isDragOver && isFlat &&
                <div
                  className={classNames(css2.dropTargetContainer, {[css2.containerVisible]: isDragOver})}
                  onDragOver={store.specCard_onDragOver}
                  onDragLeave={store.specCard_onDragLeave}>
                  <DropTarget
                    visible={!isVLPView && isDragOver}
                    title={'Products'}
                    handleDrop={store.specCard_onDrop}
                    className={css2.dropTarget}
                    disabled={!nav.params.category2}
                    title1={!nav.params.category2 && 'Requires Category 2'}
                    type={store.dragType}
                    isImage={store.dragType === 'Image'}
                  />
                </div>
              }*/}

              <GroupByGroupHeaderExtraContent />
         </Fragment>
        }
      </div>
    </div>
    )

  //const showGroupHeader = ((isCard && isExpanded && !hideChildren && !groupBy.showExpandedFirst) || isVLPView)

  // const [measureRef, bounds] = useMeasure()  // Way too expensive, don't measure like this
  // useEffect(() => {
  //   groupByStore.location = bounds
  // }, [bounds])
  return (
    // <div className={styles.sticky}>
    //   <FlipMove typeName={null} appearAnimation='fade' leaveAnimation='fade' enterAnimation='fade'>
    <div
      className={styles.headerWrapper}
      data-type='GroupByGroupHeaderWrapper'
      style={inlineStyles}
      //ref={groupView === 'card' && !isExpanded ? measureRef : null}
      onDoubleClick={groupByStore.onDoubleClick}
      onContextMenu={onContextMenu}
      // data-swatches-loc='right'
      data-swatches-loc='bottom'
      {...dataAttrs}
    >
      {false && hasToolbarPopover && <div className={styles.popoverToolbarItems}>
	      <GroupByButtons grouping={groupByStore.grouping} specStack={specStack} location='row' {...buttonToolbarProps} className={classNames(styles.rightActionSpecButtons)} data-align='right'/>
	      <FarRightFlatModeGroupByButtons/>
      </div>}

      {!hasToolbarPopover
       ? headerComponent
       : <Popover2 interactionKind='hover'
                  position='bottom-right'
                  autoFocus={false}
                  usePortal={true}
                  hoverOpenDelay={400}
                  hoverCloseDelay={0}  // When scrolling we want these to close immediately
                  modifiers={{
                    preventOverflow: {enabled: false},
                    hide: {enabled: false},
                    flip: { enabled: false},
                    offset: {
                      enabled: true,
                      options: {
                        offset: [0, -2]
                      }
                    }
                  }}
                   minimal
                  openOnTargetFocus={false}
                  disabled={sidebar.isShowingModal}
                  content={
                  <div className={styles.popoverToolbarItems}>
                    <GroupByButtons grouping={groupByStore.grouping} specStack={specStack} location='row' {...buttonToolbarProps} className={classNames(styles.rightActionSpecButtons)} data-align='right'/>
                    <FarRightFlatModeGroupByButtons/>
                  </div>}
                  className={classNames(styles.popover, {[styles.isExpanded] : isExpanded})}
                  popoverClassName={styles.floatingButtons}
       >
         {headerComponent}
       </Popover2>}

      {isFlat && showingAggregateDetails && aggregateLocation == 'inline' && !isExpanded && (showAggDetailsWhenCollapsed || forceShowInlineAggregationDetails || isSelected) && <InlineAggregateDetails/>}

      {canShowSwatchesAndHeroCards && <div className={styles.subgroupAndSwatches}>
          {ui.settings.groupByHeroCards && settings.show && (!settings.hideCollapsed || isExpanded) && <GroupByGroupHeroCards key={grouping.groupDefinition?.subGroup?.field} />}
          {showSwatches && (isExpanded || groupBy.settings.showSwatchesWhenCollapsed) && level == 0 && <GroupSwatches className={styles.swatches} />}
      </div>}
    </div>
  )
})
// GroupByGroupHeader['whyDidYouRender'] = true



// WEBPACK FOOTER //
// ./src/modules/catalog/internal/gridList/components/groupBy/GroupByCatalog/GroupByCatalog_Groups/GroupByCatalog_LoadMore/GroupByGroupHeader.tsx